import { Select, Skeleton } from "antd";
import { useContext, useEffect, useState } from "react";
import Chart from "react-google-charts";
import { useQuery } from "react-query";
import { columnChartConfigurationOptions } from "../../config";
import { SettingContext } from "../../routes";
import HTTP from "../../services/httpService";
import { formatDate } from "../../services/util";

const { Option } = Select;

function Chart1() {
    const { selectedDates } = useContext(SettingContext);
    const [start_date, end_date] = selectedDates;
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [ChartData, setChartData] = useState([]);
    const [hotel_id, setSelectedHotel] = useState("");
    const [component_id, setSelectedComponent] = useState("");
    const [formData, setFormData] = useState({
        staff_id,
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        hotel_id,
        component_id,
    });

    const {
        status: chartStatus,
        data: chartRes,
        refetch: getChart,
    } = useQuery(
        "compoentAndCheckInsPerMonth",
        async () => {
            return await HTTP("/analytics/getComponentsCheckins", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        if (formData.hotel_id !== "" && formData.component_id !== "")
            getChart();
    }, [formData]);

    const {
        status: hotelOptionStatus,
        data: hotelOptionsData,
        refetch: getHotels,
    } = useQuery(
        "hotels",
        async () => {
            return await HTTP("/dashboard/getHotels", {
                staff_id,
                hotel_type: "all",
            });
        },
        { enabled: false },
    );

    const {
        status: componentStatus,
        data: componentRes,
        refetch: getComponent,
    } = useQuery(
        "hubspot-components",
        async () => {
            return await HTTP("/dashboard/getJiraComponents", {
                staff_id,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        getHotels();
        getComponent();
    }, []);

    useEffect(() => {
        setFormData({ ...formData, hotel_id });
    }, [hotel_id]);

    useEffect(() => {
        setFormData({ ...formData, component_id });
    }, [component_id]);

    useEffect(() => {
        if (componentStatus == "success") {
            setSelectedComponent(componentRes.data[0].component_id);
        }
    }, [componentRes]);

    useEffect(() => {
        if (hotelOptionStatus == "success") {
            setSelectedHotel(hotelOptionsData.data[0].hotel_id);
        }
    }, [hotelOptionsData]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    useEffect(() => {
        if (chartStatus === "success" && chartRes.data !== null) {
            setChartData(chartRes.data);
        }
    }, [chartStatus, chartRes]);

    return (
        <>
            <div className="chart-selection-options">
                <Select
                    onChange={(e) => setSelectedHotel(e)}
                    defaultValue={hotel_id}
                    value={hotel_id}
                    loading={hotelOptionStatus !== "success"}
                    filterOption={(input, option) =>
                        option.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                    }
                    showSearch
                >
                    {hotelOptionStatus === "success" &&
                        hotelOptionsData.data.map((h) => (
                            <Option key={h.hotel_id} value={h.hotel_id}>
                                {`${h.hotel_id} - ${h.hotel_name} - ${h.hotel_id}`}
                            </Option>
                        ))}
                </Select>
                <Select
                    onChange={(e) => setSelectedComponent(e)}
                    defaultValue={component_id}
                    value={component_id}
                    loading={componentStatus !== "success"}
                    filterOption={(input, option) =>
                        option.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                    }
                >
                    {componentStatus === "success" &&
                        componentRes.data.map((c) => (
                            <Option key={c.component_id} value={c.component_id}>
                                {c.component_name}
                            </Option>
                        ))}
                </Select>
            </div>

            {ChartData.length > 0 ? (
                <Chart
                    chartType="LineChart"
                    height={"90vh"}
                    options={{
                        ...columnChartConfigurationOptions,
                        vAxes: {
                            0: { title: "Tickets" },
                            1: { title: "Check-ins" },
                        },
                        series: {
                            0: {
                                hidden: false,
                                color: "blue",
                                altColor: "transparent",
                                lineWidth: 2,
                                isVisible: true,
                                targetAxisIndex: 0,
                            },
                            1: {
                                hidden: false,
                                color: "red",
                                altColor: "transparent",
                                lineWidth: 2,
                                isVisible: true,
                                targetAxisIndex: 1,
                            },
                        },
                        legend: { position: "bottom" },
                        title: "Component And CheckIn Per Month",
                    }}
                    data={ChartData}
                />
            ) : (
                <Skeleton
                    title={false}
                    active={true}
                    paragraph={{ rows: 10 }}
                />
            )}
        </>
    );
}

export default Chart1;
